type OwnProps = {
  disabled?: boolean;
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
  showDropdown: boolean;
};

export default function Caret({ disabled, inputRef, showDropdown }: OwnProps) {
  return (
    <div className="flex pr-16 self-center z-20">
      <svg
        data-analytics-id="expand-caret"
        onClick={() => inputRef.current?.focus()}
        className={showDropdown ? 'hidden' : 'block text-blue-2'}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 6H13L8 11.5L3 6Z"
          fill={disabled ? '#AAB1C7' : '#00AED9'}
        />
      </svg>
      <svg
        data-analytics-id="collapse-caret"
        onClick={() => inputRef.current?.blur()}
        className={showDropdown ? 'block' : 'hidden'}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 10L3 10L8 4.5L13 10Z"
          fill={disabled ? '#AAB1C7' : '#00AED9'}
        />
      </svg>
    </div>
  );
}
